export default __webpack_public_path__ + "static/media/location_preview_s1_blustery_bay.217b876a.svg";